import type { CompleteFieldSelector } from '@/types/fields-api.model';
import type { ManagerMovementsResponse } from '@/types/manager.model';

const MANAGER_MOVEMENTS_FIELDS_MINIMAL = {
  negativeBalance: true,
  maxBalance: true,
  movements: {
    date: true,
    amount: true,
    email: true,
    tournamentName: true,
    registrationPaymentType: true,
    paymentMethod: true,
    tournamentValue: true,
    currentBalance: true,
    origin: true,
    chargeType: true,
  },
} as const;

const MANAGER_MOVEMENTS_FIELDS_FULL: CompleteFieldSelector<ManagerMovementsResponse> =
  {
    ...MANAGER_MOVEMENTS_FIELDS_MINIMAL,
  } as const;

export const MANAGER_MOVEMENTS_FIELDS = {
  MINIMAL: MANAGER_MOVEMENTS_FIELDS_MINIMAL,
  FULL: MANAGER_MOVEMENTS_FIELDS_FULL,
} as const;
